import React from 'react'
import { useSelector } from 'react-redux'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    backDrop: {
        '&.MuiBackdrop-root': {
            zIndex: 10000,
        },
    },
    progress: {
        '&.MuiCircularProgress-root': {
            color: '#ffffff',
        },
    },
}))

const PageLoadingContainer = (props) => {
    const classes = useStyles()
    const isLoading = useSelector((state) => state.pageLoadingState.isLoading)
    return (
        <Backdrop className={classes.backDrop} open={isLoading}>
            <CircularProgress
                variant="indeterminate"
                disableShrink
                className={classes.progress}
                size={50}
                thickness={5}
                {...props}
            />
        </Backdrop>
    )
}

export default PageLoadingContainer
